import React from "react";

export type TenantAdminPageId =
  | "users"
  | "user"
  | "control-tags"
  | "infosec"
  | "integrations"
  | "encryption-keys"
  | "secure-connections"
  | "usage"
  | "compatibility"
  | "ai";

const UsersPage = React.lazy(() => import("./users-page"));
const UserPage = React.lazy(() => import("./user-page"));
const ControlTagsPage = React.lazy(() => import("./control-tags-page"));
const InfosecPage = React.lazy(() => import("./infosec-page"));
const IntegrationsPage = React.lazy(() => import("./integrations-page"));
const EncryptionKeysPage = React.lazy(() => import("./encryption-keys-page"));
const SecureConnectionsPage = React.lazy(() => import("./secure-connections-page"));
const UsagePage = React.lazy(() => import("./usage-page"));
const CompatibilityPage = React.lazy(() => import("./compatibility-page"));
const AiPage = React.lazy(() => import("./ai-page"));

// The page each tenant admin registry entry renders, keyed by entry id; the registry itself stays free of page imports.
const adminPageElementsMap: { [K in TenantAdminPageId]: React.ReactNode } = {
  users: <UsersPage />,
  user: <UserPage />,
  "control-tags": <ControlTagsPage />,
  infosec: <InfosecPage />,
  integrations: <IntegrationsPage />,
  "encryption-keys": <EncryptionKeysPage />,
  "secure-connections": <SecureConnectionsPage />,
  usage: <UsagePage />,
  compatibility: <CompatibilityPage />,
  ai: <AiPage />,
};

export const adminPageElements = adminPageElementsMap;

export function adminPageElementForEntry(entryId: string): React.ReactNode {
  return adminPageElementsMap[entryId as TenantAdminPageId];
}
